/*
 * Module for the Account Balance Step of the Post Employment Options wizard
*/
rs.module("content/benefits/postemploymentoptions/accountbalancestep",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var separationOptionRadio = stepContainer.js(jsSelectors.separationOptionRadio, { multiple: true });
            var separationOptionDescriptionDiv = stepContainer.js(jsSelectors.separationOptionDescriptionDiv, { multiple: true });

            var selectedIndex = separationOptionRadio.index(separationOptionRadio.filter(":checked"));
            if (selectedIndex && selectedIndex >= 0) {
                showSelectedSeparationOptionDescription(selectedIndex);
            }

            // Handle the separationOptionRadio click event
            separationOptionRadio.on("change", function () {

                var selectedIndex = separationOptionRadio.index(this);
                showSelectedSeparationOptionDescription(selectedIndex);
            });

            // Show (slide down) the description for the selected payment option
            function showSelectedSeparationOptionDescription(selectedIndex) {

                // Close all quickly
                separationOptionDescriptionDiv.stop(true, true).slideUp(150);

                // Open the selected one
                separationOptionDescriptionDiv.eq(selectedIndex).stop(true, true).slideDown(150);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);